const { trackGtm4 } = require('../../../../js/functions');

module.exports = {
	init() {
		const childs = this.root.querySelectorAll('a');

		childs.forEach(child => {
			child.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_footer_navigation',
					widget_name: 'V3-Navigation',
					link_url: child.href,
					link_text: child.innerText,
					level: 'Level 1',
				});
			});
		});
	},
};
